import { goto } from '$app/navigation';

/**
 * Updates the URL parameters and navigates to the new URL if needed.
 *
 * @param {Record<string, string | number | boolean | null | undefined>} params - An object containing the parameters to be updated.
 * @param {string} redirectTo - The path to redirect to. Defaults to the current path.
 * @param {boolean} noScroll - Whether to disable scrolling. Defaults to true.
 * @param {boolean} replaceState - Whether to replace the state in history. Defaults to false.
 */
export function updateUrlParams(params: Record<string, string | number | boolean | null | undefined>, redirectTo: string = '', noScroll: boolean = true, replaceState: boolean = false): void {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);

  // Update or remove URL parameters as needed
  for (const [key, value] of Object.entries(params)) {
    if (value === null || value === undefined || value === '') {
      searchParams.delete(key);
    } else {
      searchParams.set(key, String(value));
    }
  }

  // Construct the new URL
  const newUrl = redirectTo ? `${redirectTo}?${decodeURIComponent(searchParams.toString())}` : `${url.pathname}?${decodeURIComponent(searchParams.toString())}`;

  // Redirecting using goto
  goto(newUrl, { replaceState, noScroll, keepFocus: true });
}
